/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\index.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Provisioning Server Settings module.
────────────────────────────────────────────────────────────────*/

import { api } from '../../../lib/api';

export interface ServerSetting {
    id: number;
    uuid?: string;
    name: string;
    domainId: number;
    serverDomain: string;
    sipPort: number;
    protocol: 'UDP' | 'TCP' | 'TLS';
    httpPort: number;
    httpsPort: number;
    outboundProxy?: string;
    outboundProxyPort?: number;
    createdAt: string;
    updatedAt: string;
}

// API Functions
export const getServerSettings = (domainId?: number) => {
    const params = domainId !== undefined ? `?domainId=${domainId}` : '';
    return api.get<ServerSetting[]>(`/api/apps/provisioning/server-settings${params}`).then(res => res.data);
};
export const getServerSetting = (id: number | string) => api.get<ServerSetting>(`/api/apps/provisioning/server-settings/${id}`).then(res => res.data);
export const createServerSetting = (data: Partial<ServerSetting>) => api.post<ServerSetting>('/api/apps/provisioning/server-settings', data).then(res => res.data);
export const updateServerSetting = (id: number | string, data: Partial<ServerSetting>) => api.put<ServerSetting>(`/api/apps/provisioning/server-settings/${id}`, data).then(res => res.data);
export const deleteServerSetting = (id: number | string) => api.delete(`/api/apps/provisioning/server-settings/${id}`);
